export class VueRouter {
  constructor({
    id = 0,
    path = "",
    reportLabel = "",
    name = "",
    component = "",
    icon = "",
    beforeEnter = ""
  } = {}) {
    this.id = id;
    this.path = path;
    this.reportLabel = reportLabel;
    this.name = name;
    this.component = component;
    this.icon = icon;
    this.beforeEnter = beforeEnter;
  }
}

export function CreateVueRouter(data) {
  return Object.freeze(new VueRouter(data));
}
